export default __webpack_public_path__ + "static/media/532.b75e46e5.gif";